import Image from "components/Image"
import cn from "classnames"

export default function HeaderImage({ blok }) {
  return blok?.large_screen_image?.filename ? (
    <section className="relative h-44 w-full md:h-60">
      <Image
        src={blok?.large_screen_image?.filename ?? "https://via.placeholder.com/3840x2160"}
        alt={blok?.large_screen_image?.alt ?? null}
        priority
        fill
        sizes="100vw"
        className={cn("object-cover", { "hidden md:block": blok?.small_screen_image?.filename })}
      />
      {blok?.small_screen_image?.filename ? (
        <Image
          src={blok?.small_screen_image?.filename ?? "https://via.placeholder.com/3840x2160"}
          alt={blok?.small_screen_image?.alt ?? null}
          priority
          fill
          sizes="100vw"
          className="object-cover md:hidden"
        />
      ) : null}
    </section>
  ) : null
}
